import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      navigate('/login?error=' + error);
      return;
    }

    if (token) {
      // Store token and fetch user data
      localStorage.setItem('token', token);

      const fetchUser = async () => {
        try {
          const response = await api.get('/auth/me');
          localStorage.setItem('user', JSON.stringify(response.data));
          window.location.href = '/';
        } catch (error) {
          console.error('Error fetching user:', error);
          navigate('/login?error=fetch_failed');
        }
      };

      fetchUser();
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h2>Authenticating...</h2>
        <p>Please wait while we log you in.</p>
      </div>
    </div>
  );
};

export default AuthCallback;
